export default __webpack_public_path__ + "static/media/airstrapz-cbb-1.b8becc20.png";